<template>
  <div class="thankyou-leadfrom thankyou-message-leadform">
    <div class='second-step'>
      <div class='left-icon'><span class='icon-container'><i class='icon icon-checked'></i></span></div>
        <div class='icon-right-content'>
          <p class='messsage-title'>{{heading}}</p>
          <p class='info mrgn-20' v-for="template in templateString" v-html="template.message">
          </p>
        </div>
    </div>
    <p class="info-more mrgn-20" v-if="user.isdCode === '91'">In the meantime kindly fill out the following details to help us serve you better.</p>
    <form action="" class="more-form" v-if="user.isdCode === '91'">
      <div class="row-more">
        <div class="left input-group">
          <select class="form-field" id="step2Budget" v-model="formData.budget" @input="$v.formData.$touch()" :class="{'has-value': formData.budget}">
            <option value="0 - 15,000">0 - 15,000</option>
            <option value="15,000 - 30,000">15,000 - 30,000</option>
            <option value="30,000 - 50,000">30,000 - 50,000</option>
            <option value="50,000 - 75,000">50,000 - 75,000</option>
            <option value="75,000 and Above">75,000 and Above</option>
          </select>
          <label for="step2Budget">Budget</label>
        </div>
        <div class="left input-group">
          <select class="form-field" id="step2Duration" v-model="formData.duration" @input="$v.formData.$touch()" :class="{'has-value': formData.duration}">
            <option>Upto 3 Nights</option>
            <option>4 - 7 Nights</option>
            <option>8 Nights and Above</option>
          </select>
          <label for="step2Duration">Duration</label>
        </div>

      </div>
      <div class="row-more">
        <div class="left input-group">
          <select class="form-field" id="step2Hotel" v-model="formData.hotelCategory" @input="$v.formData.$touch()" :class="{'has-value': formData.hotelCategory}">
            <option>2* - 3*</option>
            <option>3* - 4*</option>
            <option>4* - 5*</option>
            <option>Any</option>
          </select>
          <label for="step2Hotel">Hotel Category</label>
        </div>
        <div class="left input-group">
          <select class="form-field" id="step2Type" v-model="formData.packageType" @input="$v.formData.$touch()" :class="{'has-value': formData.packageType}">
            <option>Group</option>
            <option>Honeymoon</option>
            <option>Customized</option>
          </select>
          <label for="step2Type">Type of Package</label>
        </div>

      </div>
      <div class="row-more">
        <div class="left input-group">
          <select class="form-field" id="step2Prefer" v-model="formData.bestTimeToContact" @input="$v.formData.$touch()" :class="{'has-value': formData.bestTimeToContact}">
            <option>10 AM - 11 AM</option>
            <option>11 AM - 12 PM</option>
            <option>12 PM - 1 PM</option>
            <option>1 PM - 2 PM</option>
            <option>2 PM - 3 PM</option>
            <option>3 PM - 4 PM</option>
            <option>4 PM - 5 PM</option>
            <option>5 PM - 6 PM</option>
            <option>6 PM - 7 PM</option>
            <option>7 PM - 8 PM</option>
            <option>8 PM - 9 PM</option>
            <option>9 PM - 10 PM</option>
          </select>
          <label for="step2Prefer">Preferred Time to Call</label>
        </div>
      </div>
      <div class="row-more">
        <button class="btn btn-primary btn-lg" @click.prevent="submitDetails" :disabled="!$v.formData.$dirty">Submit Query</button>
      </div>

    </form>
  </div>
</template>

<script>
/* global yt_adobe lrsDetails */
import addDigitalDataObject from '../../common/tracking'
import axios from 'axios'
import urls from '../../common/URLStore'
import { required } from 'vuelidate/lib/validators'

export default {
  props: ['leadId', 'user', 'tollFreeNumber', 'leadData', 'templateString'],
  data: function() {
    return {
      formData: {
        product: 'HOLIDAYS',
        leadId: '',
        budget: '',
        duration: '',
        hotelCategory: '',
        bestTimeToContact: '',
        packageType: '',
        paxCount: 0
      }
    }
  },
  created: function() {
    // Adobe Tracking on load of pop up(2nd popup) after successful submission submit_tracking#8
    if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
      var obj = addDigitalDataObject()
      obj.page.pageInfo.popName = 'lead form success'
      yt_adobe.track('popup-load', obj)
    }

    this.formData.leadId = this.leadId
    let paxCount = 0
    let paxDetails = this.leadData.paxWiseCount
    if (paxDetails) {
      for (let key in paxDetails) {
        paxCount = paxCount + Number(paxDetails[key])
      }
    }
    this.heading = this.templateString[0].message
    this.templateString.splice(0,1)
    this.formData.paxCount = paxCount
  },
  methods: {
    changeView: function(displayTemplate) {
      this.$emit('changeView', { viewName: 'thankYou', props: { templateString: displayTemplate } })
    },
    submitDetails: function() {
      // let vm = this

      // Adobe tracking On Click Of Submit After Filling Details(2nd step) submit_tracking#9
      if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
        var obj = addDigitalDataObject()
        var request = {
          requestInfo: {
            emailID: this.leadData.customerEmailId ? this.leadData.customerEmailId : '',
            mobileNumber: this.leadData.customerMobile ? this.leadData.customerMobile : '',
            city: this.leadData.customerCityName ? this.leadData.customerCityName : '',
            leadID: this.leadId
          }
        }
        var package1 = {
          packageInfo: {
            packageComponent: 'submit Query second'
          }
        }
        obj.request = request
        obj['package'] = package1
        yt_adobe.track('contact-expert-request-initiated-second', obj)
      }

      axios
        .post(urls.leadAdditionalDetails, this.formData, {
          headers: {
            Authorization: lrsDetails.lrsApiKey,
            'com.yatra.tenant.header.tenantId': lrsDetails.lrstenantId
          }
        })
        .then(response => {
          // Adobe tracking On load of successful submission page of Send Query(3rd pop up) submit_tracking#10
          if (typeof yt_adobe !== 'undefined' && typeof yt_adobe.track == 'function') {
            var obj = addDigitalDataObject()
            var request = {
              requestInfo: {
                emailID: this.leadData.customerEmailId ? this.leadData.customerEmailId : '',
                mobileNumber: this.leadData.customerMobile ? this.leadData.customerMobile : '',
                city: this.leadData.customerCityName ? this.leadData.customerCityName : '',
                leadID: this.leadId ? this.leadId : ''
              }
            }
            var package1 = {
              packageInfo: {
                packageComponent: 'submit Query success second'
              }
            }
            obj.request = request
            obj['package'] = package1
            obj.page.pageInfo.popName = 'additional lead form success'
            yt_adobe.track('contact-expert-request-success-second', obj)
          }
          let templateStrings = response.data.messages
          templateStrings.forEach((obj, index, source) => {
            if(obj.messageParams) {
              let len = obj.messageParams.length
              if(len>0) {
                for(let i=0; i<len; i++) {
                  if(obj.message.indexOf('#'+obj.messageParams[i].name.trim()) >= 0) {
                    let replaceValue = ''
                    if(obj.messageParams[i].elem === "strong") 
                      replaceValue = '<b>'+obj.messageParams[i].value+'</b>'
                    else
                      replaceValue = obj.messageParams[i].value
                    source[index].message = source[index].message.replace('#'+obj.messageParams[i].name.trim(),replaceValue)
                  }
                }
              }
            }              
            source[index] = {message: obj.message, type: obj.elem}
          });
          let errorTemplate = [{ "message": "Oops!", "elem": "strong" }, { "message": "Your lead could not be submitted, Please try again.", "elem": "span" }]
          if (templateStrings.length === 0) {
            displayTemplate = errorTemplate
          }
          this.changeView(templateStrings)
        })
        .catch(err => {
          console.log(err)
        })
    }
  },
  validations: {
    formData: {
      budget: {
        required
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lead-form/lead-submit-step-2.vue